import React from "react";
import { t } from "i18next";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { Link } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";
import { isEmpty } from "lodash";
// import babuapp from "../assets/babu888.apk";

const MenuMobile = () => {
  const setMenuModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setMenuModal;
  });
  const setLanguageModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLanguageModal;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  return (
    <OutsideClickHandler onOutsideClick={() => setMenuModal(false)}>
      <aside
        className="mobile-navigation-drawer v-navigation-drawer v-navigation-drawer--absolute v-navigation-drawer--is-mobile v-navigation-drawer--open v-navigation-drawer--temporary theme--light"
        left
        data-booted="true"
        style={{
          height: "100%",
          top: "0px",
          "-webkit-transform": "translateX(0%)",
          "-ms-transform": "translateX(0%)",
          transform: "translateX(0%)",
          width: "256px",
        }}
      >
        <div className="v-navigation-drawer__content">
          <div className="row">
            <div className="mobile-drawer-menu-header-section col col-12">
              <Link
                to="/"
                className="mobile-drawer-menu-logo router-link-exact-active router-link-active"
              >
                <img
                  src="/assets/new/babu88_logo_black.svg"
                  alt
                  width={180}
                  height={30}
                  className="mt-4"
                />
              </Link>
              <button
                onClick={() => setMenuModal(false)}
                type="button"
                style={{ color: "black" }}
                className="v-icon notranslate mobile-drawer-menu-icon v-icon--link mdi mdi-menu theme--light"
              />
            </div>
          </div>
          <hr
            role="separator"
            aria-orientation="horizontal"
            className="my-4 mx-4 v-divider theme--light"
          />
          <div
            role="list"
            className="v-list pb-16 mobileMenuListItem v-sheet theme--light v-list--dense v-list--nav"
          >
            <div
              role="listbox"
              className="v-item-group theme--light v-list-item-group"
            >
              <Link
                to="/promotion"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_promotion.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">{t("Promotion")}</div>
                </div>
              </Link>
              <Link
                to="/reward"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_rewards.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">
                    <div className="row no-gutters align-center justify-start">
                      <div className="mt-1 col col-auto">{t("Rewards")}</div>
                      <div
                        className="text-center col col-2"
                        style={{
                          "margin-left": "5px",
                          "background-color": "rgb(4, 178, 43)",
                          "border-radius": "8px",
                          color: "white",
                          "font-size": "10px",
                        }}
                      >
                        <span className="font-weight-bold">new</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
              <Link
                to="/vip"
                className="menu-item-1 v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_VIP.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title list-item-title">
                    {t("VIP")}
                  </div>
                </div>
              </Link>
              {/* <a
                href="/vip/vipProfile"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/icon/bettingPass.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">{t("BigPass")}</div>
                </div>
              </a> */}
              <Link
                to="/refer"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_referral.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">{t("ReferAndEarn")}</div>
                </div>
              </Link>
              <Link
                to="/affiliateLink"
                role="option"
                aria-selected="false"
                className="v-list-item v-list-item--link theme--light"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_agents.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">
                    {t("AgentAffiliate")}
                  </div>
                </div>
              </Link>
            </div>
            <hr
              role="separator"
              aria-orientation="horizontal"
              className="my-4 mx-4 v-divider theme--light"
            />
            <span className="mobile-drawer-itemgroup-title">{t("Games")}</span>
            <div
              role="listbox"
              className="v-item-group theme--light v-list-item-group"
            >
              <Link
                to="/casino/slot"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_rng.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">
                    <div className="row no-gutters align-center justify-start">
                      <div className="mt-1 col col-auto">
                        {t("SlotGamesNav")}
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
              <Link
                to="/casino/casino"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_ld.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">
                    <div className="row no-gutters align-center justify-start">
                      <div className="mt-1 col col-auto">
                        {t("LiveCasinoNav")}
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
              <Link
                to="/casino/crash"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_crash.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">
                    <div className="row no-gutters align-center justify-start">
                      <div className="mt-1 col col-auto">{t("Crash")}</div>
                      <div
                        className="text-center col col-2"
                        style={{
                          "margin-left": "2px",
                          "background-color": "rgb(4, 178, 43)",
                          "border-radius": "8px",
                          color: "white",
                          "font-size": "10px",
                        }}
                      >
                        <span className="font-weight-bold">new</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>

              <Link
                to="/casino/table"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_table.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">
                    <div className="row no-gutters align-center justify-start">
                      <div className="mt-1 col col-auto">{t("TableGames")}</div>
                    </div>
                  </div>
                </div>
              </Link>

              <Link
                to="/casino/fishing"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <img
                    src="/assets/new/icon_fishing.webp"
                    alt
                    width={25}
                    height={25}
                  />
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">
                    <div className="row no-gutters align-center justify-start">
                      <div className="mt-1 col col-auto">{t("Fishing")}</div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            <hr
              role="separator"
              aria-orientation="horizontal"
              className="my-4 mx-4 v-divider theme--light"
            />
            <span className="mobile-drawer-itemgroup-title">{t("Others")}</span>
            <div
              role="listbox"
              className="v-item-group theme--light v-list-item-group"
            >
              <div
                onClick={() => setLanguageModal(true)}
                tabIndex={0}
                role="option"
                aria-selected="false"
                className="v-list-item v-list-item--link theme--light"
              >
                <div className="v-list-item__icon">
                  <button
                    type="button"
                    className="v-btn v-btn--icon v-btn--round theme--light v-size--small"
                    style={{ "margin-left": "-3px" }}
                  >
                    <span className="v-btn__content">
                      <div
                        className="v-avatar language-button"
                        style={{
                          height: "25px",
                          "min-width": "25px",
                          width: "25px",
                        }}
                      >
                        <img src="/assets/new/icon_language.webp" />
                      </div>
                    </span>
                  </button>
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">{t("Language")}</div>
                </div>
              </div>
              <a
                href="/info/faq"
                className="v-list-item v-list-item--link theme--light"
                tabIndex={0}
                role="option"
                aria-selected="false"
              >
                <div className="v-list-item__icon">
                  <button
                    type="button"
                    className="v-btn v-btn--icon v-btn--round theme--light v-size--small"
                    style={{ "margin-left": "-3px" }}
                  >
                    <span className="v-btn__content">
                      <div
                        className="v-avatar"
                        style={{
                          height: "25px",
                          "min-width": "25px",
                          width: "25px",
                        }}
                      >
                        <img src="/assets/new/icon_FAQ.svg" />
                      </div>
                    </span>
                  </button>
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title">{t("FAQ")}</div>
                </div>
              </a>
              <div
                tabIndex={0}
                role="option"
                aria-selected="false"
                className="v-list-item v-list-item--link theme--light"
              >
                <div className="v-list-item__icon">
                  <button
                    type="button"
                    className="v-btn v-btn--icon v-btn--round theme--light v-size--small"
                    style={{ "margin-left": "-3px" }}
                  >
                    <span className="v-btn__content">
                      <div
                        className="v-avatar"
                        style={{
                          height: "25px",
                          "min-width": "25px",
                          width: "25px",
                        }}
                      >
                        <img src="/assets/new/icon_downloadapp.svg" />
                      </div>
                    </span>
                  </button>
                </div>
                <div className="v-list-item__content">
                  <div className="v-list-item__title"><a href={"babu99"}  download="babu99" target='_blank' style={{textDecoration:`none`}}>{t("DOWNLAOD_APP")}</a></div>
                </div>
              </div>
            </div>
            <hr
              role="separator"
              aria-orientation="horizontal"
              className="my-4 mx-4 v-divider theme--light"
            />

            {!isEmpty(user) && (
              <div
                role="listbox"
                className="v-item-group theme--light v-list-item-group"
              >
                <div
                  onClick={() => logoutUser()}
                  tabIndex={0}
                  role="option"
                  aria-selected="false"
                  className="v-list-item v-list-item--link theme--light"
                >
                  <div className="v-list-item__icon">
                    <img
                      src="/assets/new/logout.svg"
                      alt
                      width={25}
                      height={25}
                    />
                  </div>
                  <div className="v-list-item__content">
                    <div className="v-list-item__title">{t("Logout")}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="v-navigation-drawer__border" />
      </aside>
    </OutsideClickHandler>
  );
};

export default MenuMobile;
